export const EMPLOYEE_SELECTION_MODE = 'selected';
export const ALL_MATCHING_SELECTION_MODE = 'all_matching';

export const canSubmitPeriodActivityAction = ({ selectionMode, selected, total }) => {
  if (selectionMode === ALL_MATCHING_SELECTION_MODE) return total > 0;

  return Array.isArray(selected) && selected.length > 0;
};

export const buildPeriodActivityPayload = ({ filters, selectionMode, selected }) => {
  if (selectionMode === ALL_MATCHING_SELECTION_MODE) {
    return {
      filters: filters || [],
      apply_to_all: true,
    };
  }

  return {
    filters: filters || [],
    employee_hash_ids: selected || [],
  };
};
